import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

import style from './index.module.scss';

@Component({ name: 'Role' })
export default class Role extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private role: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.role = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.role) {
      this.role = val;
    }
  }

  public onValidator(): boolean {
    if (this.role === undefined || this.role === null) {
      this.errorMsg = '请选择工作性质';
      return false;
    }

    return true;
  }

  private onChangeRole(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.Role}>
        <Field
          v-model={this.role}
          onChange={() => this.onChangeRole(this.role)}
          sub={true}
          label="工作性质"
          type="select"
          dictApi={DictApi.getWorkType}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
